export const APP_LOCALES = ['en', 'fr', 'it', 'de', 'hy', 'ru'] as const

export type AppLocale = (typeof APP_LOCALES)[number]

export function normalizeAppLocale(value: unknown): AppLocale | null {
  if (value == null) return null

  const raw = String(value).trim().toLowerCase().replace(/_/g, '-')
  if (!raw || raw === 'null' || raw === 'undefined') return null
  if ((APP_LOCALES as readonly string[]).includes(raw)) return raw as AppLocale

  const base = raw.split('-')[0]
  if ((APP_LOCALES as readonly string[]).includes(base)) return base as AppLocale

  return null
}
